import React from 'react'
import { User, LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { UserAvatar } from '@/components/atoms/UserAvatar'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/config/routes'

interface ProfileDropdownProps {
  user: {
    firstName: string
    lastName: string
    email: string
    profileImage?: string | null
  } | null
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onLogout: () => void
}

export const ProfileDropdown: React.FC<ProfileDropdownProps> = ({
  user,
  isOpen,
  onOpenChange,
  onLogout
}) => {
  const navigate = useNavigate()

  const handleProfileClick = () => {
    navigate(ROUTES.PROFILE)
    onOpenChange(false)
  }
  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={onOpenChange}>
      <DropdownMenu.Trigger asChild>
        <Button
          variant="ghost"
          className="relative h-10 w-10 rounded-full p-0 ml-2 hover:bg-muted/50 transition-all duration-200 hover:scale-105"
        >
          <UserAvatar
            firstName={user?.firstName || "John"}
            lastName={user?.lastName || "Doe"}
            profileImage={user?.profileImage}
          />
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="min-w-[200px] glassmorphism rounded-lg shadow-lg p-1 z-50"
          sideOffset={8}
          align="end"
        >
          <div className="px-3 py-2 border-b border-white/20 dark:border-white/10">
            <p className="text-sm font-medium text-foreground">
              {user ? `${user.firstName} ${user.lastName}` : "John Doe"}
            </p>
            <p className="text-xs text-muted-foreground">
              {user?.email || "john.doe@example.com"}
            </p>
          </div>
          <DropdownMenu.Item 
            className="flex items-center gap-2 px-3 py-2 text-sm text-foreground rounded-md hover:bg-white/20 dark:hover:bg-white/10 cursor-pointer outline-none transition-colors"
            onClick={handleProfileClick}
          >
            <User className="w-4 h-4" />
            Profile
          </DropdownMenu.Item>
          <DropdownMenu.Separator className="my-1 h-px bg-white/20 dark:bg-white/10" />
          <DropdownMenu.Item
            className="flex items-center gap-2 px-3 py-2 text-sm rounded-md hover:bg-red-500/20 cursor-pointer outline-none text-red-600 dark:text-red-400 transition-colors"
            onClick={onLogout}
          >
            <LogOut className="w-4 h-4" />
            Logout
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}